import React from 'react'
import '../../../App.css'
import Mission from '../../../img/mission.png';
import Vision from '../../../img/vision.png';
import TeamImg from '../../../img/lirilBansal.png';
import SwatiImg from '../../../img/swatiAgarwal.png';

const About = () => {
   return (
      <>
         <div className="audit-page">

            {/* Cover Section */}
            <section className="audit-cover about-cover">
               <div className="container">
                  <div className="audit-cover-para">
                     <h1 style={{ color: "#f1f1f1", fontSize: "42px" }}>ABOUT US</h1>
                  </div>
               </div>
            </section>

            {/* Content Section */}
            <section className="audit-page-content container" style={{ marginBottom: "40px" }}>

               <p>
                  Our firm ‘Swati Liril Bansal & Company’ established in year 2014 is a chartered accountancy firm operating from Delhi all over India. Our firm provides diversified professional services to its clients under single roof.               </p>

               <p>
                  With the experience of years & years, we facilitate our clients through our professional and reliable consultancy solutions that includes direct taxes, indirect taxes, company law matters, statutory audit, internal audit, corporate advisory and project financing etc.               </p>

               <div className="abt-cover">

                  {/* Mission */}
                  <h1>Our Mission</h1>
                  <div className='mission'>
                     <div className="mission-content">
                        <p>
                           We are dedicated to provide highest quality of services to our clients. We strongly believe in meeting all the current and the future needs of our clients for long term success of clients.</p>

                        <p>We work towards creating an open environment that encourages creative thinking that leads to innovative ideas and innovative ideas inspire change and change is essence of life that leads to way to success.</p>
                     </div>

                     <div className="mission-img">
                        <img src={Mission} alt="Mission" />
                     </div>
                  </div>

                  {/* Vision */}
                  <div className='vision'>
                     <div className="vision-img">
                        <img src={Vision} alt="Vision" />
                     </div>

                     <div className="vision-detail">
                        <h1>Our Vision</h1>
                        <p>
Our vision is to be recognized as best CA firm all over India. We are working PAN India and would like to work outside India. To Develop a global recognition and we are committed to work hard towards this positive vision.                        </p>
                     </div>
                  </div>
                  {/* team section */}
                  <div className="team-section">

                     <h1 className="team-heading">OUR TEAM</h1>

                     <p>
                        Our Team consists of highly experienced CAs, CS, and consultants and subject experts, technical staff and a dedicated team of experts. We have a highly qualified and responsive team comprising of young as well as senior professionals driven by a spirit of collaboration and team approach to service. This rich history has given us an unparalleled insight into our clientele's industries. Our clients get end to end, tailored services and find themselves working with a team that understand the challenges they face.
                     </p>
                     <br></br><br></br>
                     <div className="team-wrapper">

                        {/* LEFT CONTENT */}
                        <div className="team-left">
                           <h2 className="team-name">CA Liril Bansal</h2>
                           
                           <h6 className="team-subtitle">A Few Words About Us</h6>

                           <p>Liril Bansal is a Fellow Chartered Accountant practicing since 2014 with plus more than 10 years of post-qualification experience, specializing in business setup in India, skilling-up project finance, end-to-end compliance support from incorporation to execution, business advisory, taxation, and regulatory compliance for Micro, Small and Medium Enterprises (MSMEs). He works closely with entrepreneurs and growing enterprises to structure, finance, and operationalize businesses with clarity, compliance discipline, and long-term sustainability.</p>
                           <p>Over the years, he has developed a strong professional foundation in handling income tax matters, GST advisory and litigation, corporate and ROC compliances, and business structuring for a diverse range of clients. His approach blends technical expertise with practical insight, ensuring clients receive clear, implementable, and result-oriented solutions.</p>
                           <p>As the Managing Partner of Swati Liril Bansal & Co., he leads assignments involving tax planning, assessment proceedings, departmental representations, corporate compliance management, and regulatory advisory. He is also an active member of the Sales Tax Bar Association, reflecting his commitment to professional excellence and continuous engagement with evolving tax laws and regulatory developments.</p>
                           <p>Beyond his professional practice, he has actively contributed to knowledge sharing and industry development by conducting various seminars and awareness sessions. Through these initiatives, he has guided numerous MSMEs on compliance management, regulatory structuring, financial discipline, and government policy benefits, helping businesses strengthen their operational and compliance frameworks.</p>
                           <p>He is also the Founder of Shri Nanak Foundation, through which he works towards the upliftment and empowerment of MSMEs. Through this initiative, he contributes to society by promoting financial awareness, regulatory education, and sustainable business practices, thereby helping small businesses become stronger and more self-reliant.</p>
                           <p>A significant focus of his professional practice is advising MSMEs on regulatory and tax structuring, Udyam registration, government loan and subsidy schemes, and protection against delayed payments under the Micro, Small and Medium Enterprises Development Act, 2006, including representation in MSME Samadhaan matters. Through his work, he strives to bridge the gap between policy framework and ground-level implementation, enabling businesses to achieve sustainable and compliant growth.</p>
                        </div>
                        {/* RIGHT IMAGE */}
                        <div className="team-right">
                           <img
                              src={TeamImg}
                              alt="CA Liril Bansal"
                              className="team-img"
                           />
                        </div>

                     </div>
                     <br></br><br></br>
                     <div className="team-wrapper">

                        {/* LEFT CONTENT */}
                        <div className="team-left">
                           <h2 className="team-name">CA Swati Aggarwal</h2>
                           <h6 className="team-subtitle">A Few Words About Us</h6>

                           <p>Swati Aggarwal is a Fellow Member of the Institute of Chartered Accountants of India (ICAI) with over a decade of professional experience in taxation, regulatory compliance, and litigation advisory. She is the Managing Partner at Swati Liril Bansal & Company since 2023, leading the firm’s litigation and advisory practice.</p>
                           <p>Prior to establishing her independent practice, she worked as a Manager at S. S. Kothari Mehta & Company for five years, where she gained extensive experience in statutory audit, internal audit and preparation of SOPs assignments across diverse industries. This strong auditing background provides her with a deep understanding of financial systems, risk evaluation, and compliance frameworks, which further strengthens her litigation and advisory approach.</p>
                           <p>She specializes in handling complex Income Tax and GST litigation matters, representing clients before various tax authorities and appellate forums.</p>
                           <p>Her practice is primarily focused on litigation-oriented tax advisory, where she assists businesses and individuals in managing assessments, reassessments, and dispute resolution proceedings. She is known for her strong drafting skills, detailed documentation approach, and structured legal representation, ensuring effective and strategic handling of departmental matters.</p>
                           <p>Swati works closely with clients to safeguard their interests, provide practical legal solutions, and navigate evolving tax regulations with clarity and confidence. Her litigation-driven practice focuses on minimizing tax exposure, ensuring compliance, and delivering effective representation across all stages of departmental proceedings.</p>

                        </div>
                        {/* RIGHT IMAGE */}
                        <div className="team-right">
                           <img
                              src={SwatiImg}
                              alt="CA Swati Aggarwal"
                              className="team-img"
                           />
                        </div>

                     </div>
                  </div>
               </div>
            </section>
         </div>
      </>
   )
}

export default About;